/**
 * DevExtreme (ui/context_menu/ui.menu_base.edit.strategy.js)
 * Version: 19.2.6
 * Build date: Thu Jan 30 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
"use strict";
var _renderer = require("../../core/renderer");
var _renderer2 = _interopRequireDefault(_renderer);
var _iterator = require("../../core/utils/iterator");
var _uiCollection_widgetEditStrategy = require("../collection/ui.collection_widget.edit.strategy.plain");
var _uiCollection_widgetEditStrategy2 = _interopRequireDefault(_uiCollection_widgetEditStrategy);

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    }
}

function _typeof(obj) {
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) {
        _typeof = function(obj) {
            return typeof obj
        }
    } else {
        _typeof = function(obj) {
            return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj
        }
    }
    return _typeof(obj)
}

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function")
    }
}

function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) {
            descriptor.writable = true
        }
        Object.defineProperty(target, descriptor.key, descriptor)
    }
}

function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) {
        _defineProperties(Constructor.prototype, protoProps)
    }
    if (staticProps) {
        _defineProperties(Constructor, staticProps)
    }
    return Constructor
}

function _possibleConstructorReturn(self, call) {
    if (call && ("object" === _typeof(call) || "function" === typeof call)) {
        return call
    }
    return _assertThisInitialized(self)
}

function _assertThisInitialized(self) {
    if (void 0 === self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called")
    }
    return self
}

function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o)
    };
    return _getPrototypeOf(o)
}

function _inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) {
        throw new TypeError("Super expression must either be null or a function")
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) {
        _setPrototypeOf(subClass, superClass)
    }
}

function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o
    };
    return _setPrototypeOf(o, p)
}
var MenuBaseEditStrategy = function(_PlainEditStrategy) {
    _inherits(MenuBaseEditStrategy, _PlainEditStrategy);

    function MenuBaseEditStrategy() {
        _classCallCheck(this, MenuBaseEditStrategy);
        return _possibleConstructorReturn(this, _getPrototypeOf(MenuBaseEditStrategy).apply(this, arguments))
    }
    _createClass(MenuBaseEditStrategy, [{
        key: "_getPlainItems",
        value: function() {
            return (0, _iterator.map)(this._collectionWidget.option("items"), function getMenuItems(item) {
                return item.items ? [item].concat((0, _iterator.map)(item.items, getMenuItems)) : item
            })
        }
    }, {
        key: "_stringifyItem",
        value: function(item) {
            var _this = this;
            return JSON.stringify(item, function(key, value) {
                if ("template" === key) {
                    return _this._getTemplateString(value)
                }
                return value
            })
        }
    }, {
        key: "_getTemplateString",
        value: function(template) {
            var result;
            if ("object" === _typeof(template)) {
                result = (0, _renderer2.default)(template).text()
            } else {
                result = template.toString()
            }
            return result
        }
    }]);
    return MenuBaseEditStrategy
}(_uiCollection_widgetEditStrategy2.default);
module.exports = MenuBaseEditStrategy;



//////////////////
// WEBPACK FOOTER
// ./~/devextreme/ui/context_menu/ui.menu_base.edit.strategy.js
// module id = 1044
// module chunks = 0